<template>
  <div>
    <c-card title="부서 상세" class="cardClassDetailForm no-margin">
      <template slot="card-description">
        <c-plant 
          style="display:inline-block"
          class="custom-dept-plant"
          type="edit" 
          label=""
          name="plantCd" 
          v-model="filterPlantCd" />
      </template>
      <template slot="card-button">
        <q-btn-group outline >
          <c-btn 
            v-if="editable" 
            label="선택" 
            icon="check"
            @btnClicked="select" />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-12">
          <q-tree
            ref="dept-multi"
            :nodes="deptTree"
            tick-strategy="strict"
            node-key="deptCd"
            label-key="deptName"
            children-key="children"
            no-nodes-label="부서 정보가 없습니다."
            :default-expand-all="false"
            :ticked.sync="checkDepts"
          />
        </div>
      </template>
    </c-card>
  </div>
</template>

<script>
import arrayToTree from 'array-to-tree';
export default {
  name: 'dept-multi-pop',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          plantCd: '',
          parentCheckDepts: '',
        }
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    },
    plantCd: {
      type: String,
    },
  },
  data() {
    return {
      filterPlantCd: null,
      checkDepts: [],
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    depts() {
      let list = []; // this.$store.state.systemInfo.depts;
      if (this.$store.getters.user.plantCds !== null && this.$store.getters.user.plantCds !== '') {
        let plantCds = this.$store.getters.user.plantCds.split(',');
        this.$_.forEach(this.$store.state.systemInfo.depts, _item => {
          let index = plantCds.findIndex(a => a === _item.plantCd);
          if (index > -1) {
            list.push(_item);
          }
        })
      }
      if (this.filterPlantCd) {
        list = this.$_.filter(list, { plantCd: this.filterPlantCd });
      } 

      if (this.editable && !this.disabled) {
        // 사용여부가 Y인 것만 리스트에 표현한다.
        // default : 사용여부 상관없이 전체
        list = this.$_.filter(list, { useFlag: 'Y' });
      }
      return list;
    },
    deptTree() {
      let val = this.convertTree(this.depts);
      return val ? val : [];
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      if (this.popupParam.parentCheckDepts) {
        this.checkDepts = this.popupParam.parentCheckDepts.split(',');
      }
      if (this.popupParam.plantCd) {
        this.$set(this.$data, 'filterPlantCd', this.popupParam.plantCd)
      }
    },
    convertTree(_treeBases) {
      if (!_treeBases || _treeBases.length <= 0) return null;
      var tree = arrayToTree(_treeBases, {
        parentProperty: 'upDeptCd',
        customID: 'deptCd',
      });
      return tree;
    },
    select() {
      if (!this.checkDepts || this.checkDepts.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '부서를 지정하세요.', // 사용자를 먼저 지정하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', this.$refs['dept-multi'].getTickedNodes());
      }
    },
  }
};
</script>
<style lang="sass">
.custom-dept-plant
  label
    padding: 0px !important
    .q-field__inner
      padding: 0px !important
</style>